import React from 'react';
import clsx from 'clsx';
import { Table } from 'semantic-ui-react';
import { cohortUrl } from '@/constants/urls';
import {
  columnCode,
  columnCreatedOn,
  columnUpdatedOn,
  columnDescription,
  columnNameLink,
  columnMultiSelect,
  columnTools,
  columnVisibility,
  columnStatus,
  hasColumn,
} from '@/constants/fields';
import SimpleCell from '@/components/table/SimpleCell';
import VisibilityCell from '@/components/table/VisibilityCell';
import NameDescriptionRow from '@/components/table/NameDescriptionRow';
import CohortTools from '../containers/CohortTools';
import CohortStatusCell from '../status/containers/CohortStatusCell';

const CohortRow = ({
  category,
  cohort,
  columns = [
    columnMultiSelect,
    columnNameLink,
    columnCode,
    columnDescription,
    columnCreatedOn,
    columnUpdatedOn,
    columnVisibility,
    columnTools,
  ],
  className,
  onCheckBoxClick,
  selectable,
  upward,
}) => (
  <NameDescriptionRow
    className={clsx('aridhia-cohort-row', className)}
    columns={columns}
    description={cohort.description}
    entity="cohort"
    href={cohortUrl(cohort)}
    name={cohort.name}
    onSelect={() => onCheckBoxClick(cohort.code)}
    selected={cohort.selected}
    selectable={selectable}
  >
    {hasColumn(columns, columnVisibility) && (<VisibilityCell visibility={cohort.visibility} />)}
    {hasColumn(columns, columnCreatedOn) && (<SimpleCell content={cohort.createdOn} />)}
    {hasColumn(columns, columnUpdatedOn) && (<SimpleCell content={cohort.updatedOn} />)}
    {hasColumn(columns, columnStatus) && (<CohortStatusCell cohort={cohort} />)}
    {hasColumn(columns, columnTools) && (
      <Table.Cell collapsing>
        <CohortTools
          url={cohortUrl(cohort, '#')}
          upward={upward}
          category={category}
          cohort={cohort}
        />
      </Table.Cell>
    )}
  </NameDescriptionRow>
);

export default CohortRow;
